/// <reference path="../../../../teva/selectbox/selectbox.ts" />

namespace OfficeGuy.Inputs {
    export class SelectBox {
        static Init(Container = null): void {
            Teva.SelectBox.Enable($("select", Container).removeClass("teva-selectbox"), {
                AllowSearch: false,
                AllowClear: false,
                FormatResultItem: function (Item) {
                    if (Item.data == null || Item.data.title == null || Item.data.title == "")
                        return Item.text;
                    return "<div class=\"teva-selectbox-search-results-result-title\">" + Item.text + "</div><div class=\"teva-selectbox-search-results-result-description\">" + Item.data.title + "</description>";
                },
                PlaceHolderText: function (Instance) {
                    var ToReturn = Instance.$Input.attr("placeholder");
                    if (!ToReturn)
                        return "";
                    return ToReturn;
                }
            });
        }
    }
}

$(document).on("Teva.InitEditors", function (Event, Container) {
    OfficeGuy.Inputs.SelectBox.Init(Container);
});